import { render, staticRenderFns } from "./PropostasConsorcio.vue?vue&type=template&id=2cb7cfe6&scoped=true"
import script from "./PropostasConsorcio.vue?vue&type=script&lang=js"
export * from "./PropostasConsorcio.vue?vue&type=script&lang=js"
import style0 from "./PropostasConsorcio.vue?vue&type=style&index=0&id=2cb7cfe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7cfe6",
  null
  
)

export default component.exports